// import React, { useState } from "react";
// import Dialog from "../components/Dialog";
// import { APPS_SCRIPT_URL } from "../config/constants";

// const AlumniStudentsForm = ({ memberType }) => {
//   const [formData, setFormData] = useState({});
//   const [profilePicture, setProfilePicture] = useState(null);
//   const [dialog, setDialog] = useState(null);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
//       if (!validTypes.includes(file.type)) {
//         setDialog({
//           type: "error",
//           message: "Invalid file type. Please upload an image (jpg, png, gif).",
//         });
//         return;
//       }
//       if (file.size > 3 * 1024 * 1024) {
//         setDialog({
//           type: "error",
//           message: "File size exceeds 3MB. Please upload a smaller image.",
//         });
//         return;
//       }
//       setProfilePicture(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const submissionData = new URLSearchParams({ ...formData, memberType });

//       if (profilePicture) {
//         const reader = new FileReader();
//         reader.onload = async function(event) {
//           const base64Data = event.target.result.split(',')[1];
//           submissionData.append("profilePicture", base64Data);
//           submissionData.append("profilePictureName", profilePicture.name);
//           submissionData.append("profilePictureMimeType", profilePicture.type);
          
//           await sendFormData(submissionData);
//         };
//         reader.readAsDataURL(profilePicture);
//       } else {
//         await sendFormData(submissionData);
//       }
//     } catch (err) {
//       setDialog({
//         type: "error",
//         message: "An error occurred. Please try again.",
//       });
//     }
//   };

//   const sendFormData = async (formData) => {
//     const response = await fetch(APPS_SCRIPT_URL, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: formData.toString(),
//     });

//     const data = await response.json();

//     if (data.result === "success") {
//       setDialog({
//         type: "success",
//         message: "Your registration has been submitted successfully!",
//       });
//       setFormData({});
//       setProfilePicture(null);
//     } else {
//       setDialog({
//         type: "error",
//         message: data.error || "Submission failed. Please try again.",
//       });
//     }
//   };
 

//   const currentYear = new Date().getFullYear();
//   const yearOptions = Array.from({ length: 50 }, (_, i) => currentYear - i);

//   const alumniFields = [
//     { name: "name", label: "Name", type: "text" },
//     { name: "email", label: "Email", type: "email" },
//     { name: "mobileNumber", label: "Mobile Number", type: "tel" },
//     { name: "whatsappNumber", label: "WhatsApp Number", type: "tel" },
//     { name: "address", label: "Current Address", type: "text" },
//     { name: "state", label: "State In India", type: "text" },
//     {
//       name: "universityAttended",
//       label: "University Attended in India",
//       type: "text",
//     },
//     { name: "courseStudied", label: "Course Studied", type: "text" },
//     {
//       name: "completedYear",
//       label: "Completed Year",
//       type: "select",
//       options: yearOptions,
//     },
//   ];

//   return (
//     <div>
//       {dialog && (
//         <Dialog
//           type={dialog.type}
//           message={dialog.message}
//           onClose={() => setDialog(null)}
//         />
//       )}
//       <form onSubmit={handleSubmit}>
//         {alumniFields.map((field) => (
//           <div key={field.name} className="mb-4">
//             <label
//               htmlFor={field.name}
//               className="block text-sm font-medium text-gray-700 mb-1"
//             >
//               {field.label}
//             </label>
//             {field.type === "select" ? (
//               <select
//                 id={field.name}
//                 name={field.name}
//                 value={formData[field.name] || ""}
//                 onChange={handleInputChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 required
//               >
//                 <option value="">Select {field.label}</option>
//                 {field.options.map((option) => (
//                   <option key={option} value={option}>
//                     {option}
//                   </option>
//                 ))}
//               </select>
//             ) : (
//               <input
//                 type={field.type}
//                 id={field.name}
//                 name={field.name}
//                 value={formData[field.name] || ""}
//                 onChange={handleInputChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 required
//               />
//             )}
//           </div>
//         ))}
//         <div className="mb-4">
//           <label
//             htmlFor="profilePicture"
//             className="block text-sm font-medium text-gray-700 mb-1"
//           >
//             Profile Picture
//           </label>
//           <input
//             type="file"
//             id="profilePicture"
//             name="profilePicture"
//             accept="image/jpeg,image/png,image/gif"
//             onChange={handleFileChange}
//             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>
//         <div className="mt-6">
//           <button
//             type="submit"
//             className="w-full py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors duration-200"
//           >
//             Submit
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AlumniStudentsForm;


import React, { useRef, useState } from "react";
import Dialog from "../components/Dialog";
import { APPS_SCRIPT_URL } from "../config/constants";

const AlumniStudentsForm = ({ memberType }) => {
  const [formData, setFormData] = useState({});
  const [profilePicture, setProfilePicture] = useState(null);
  const [dialog, setDialog] = useState(null);
  const fileInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!validTypes.includes(file.type)) {
        setDialog({
          type: "error",
          message: "Invalid file type. Please upload an image (jpg, png, gif).",
        });
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        setDialog({
          type: "error",
          message: "File size exceeds 3MB. Please upload a smaller image.",
        });
        return;
      }
      setProfilePicture(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submissionData = new URLSearchParams({ ...formData, memberType });

      if (profilePicture) {
        const reader = new FileReader();
        reader.onload = async function(event) {
          const base64Data = event.target.result.split(',')[1];
          submissionData.append("profilePicture", base64Data);
          submissionData.append("profilePictureName", profilePicture.name);
          submissionData.append("profilePictureMimeType", profilePicture.type);
          
          await sendFormData(submissionData);
        };
        reader.readAsDataURL(profilePicture);
      } else {
        await sendFormData(submissionData);
      }
    } catch (err) {
      setDialog({
        type: "error",
        message: "An error occurred. Please try again.",
      });
    }
  };

  const sendFormData = async (formData) => {
    const response = await fetch(APPS_SCRIPT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });

    const data = await response.json();

    if (data.result === "success") {
      setDialog({
        type: "success",
        message: "Your registration has been submitted successfully!",
      });
      setFormData({});
      setProfilePicture(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } else {
      setDialog({
        type: "error",
        message: data.error || "Submission failed. Please try again.",
      });
    }
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 50 }, (_, i) => currentYear - i);

  const alumniFields = [
    { name: "name", label: "Name", type: "text" },
    { name: "email", label: "Email", type: "email" },
    { name: "mobileNumber", label: "Mobile Number", type: "tel" },
    { name: "whatsappNumber", label: "WhatsApp Number", type: "tel" },
    { name: "address", label: "Current Address", type: "text" },
    { name: "state", label: "State In India", type: "text" },
    {
      name: "universityAttended",
      label: "University Attended in India",
      type: "text",
    },
    { name: "courseStudied", label: "Course Studied", type: "text" },
    {
      name: "completedYear",
      label: "Completed Year",
      type: "select",
      options: yearOptions,
    },
  ];

  return (
    <div>
      {dialog && (
        <Dialog
          type={dialog.type}
          message={dialog.message}
          onClose={() => setDialog(null)}
        />
      )}
      <form onSubmit={handleSubmit}>
        {alumniFields.map((field) => (
          <div key={field.name} className="mb-4">
            <label
              htmlFor={field.name}
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              {field.label}
            </label>
            {field.type === "select" ? (
              <select
                id={field.name}
                name={field.name}
                value={formData[field.name] || ""}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select {field.label}</option>
                {field.options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={field.type}
                id={field.name}
                name={field.name}
                value={formData[field.name] || ""}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            )}
          </div>
        ))}
        <div className="mb-4">
          <label
            htmlFor="profilePicture"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Profile Picture
          </label>
          <input
            type="file"
            id="profilePicture"
            name="profilePicture"
            accept="image/jpeg,image/png,image/gif"
            onChange={handleFileChange}
            ref={fileInputRef}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mt-6">
          <button
            type="submit"
            className="w-full py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors duration-200"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AlumniStudentsForm;